var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMairiniLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 12.7 12.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.038999 .0030046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.7968 4.7051 0.0073 1.301c-1.108 0.0088-2.3772 0.0053-3.026 0.0021-0.04044-1.7102-0.02561-2.9806-0.04034-4.9079 0.92826 1.2699 1.9214 2.5141 3.059 3.6048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.2371 5.7722a0.90503 0.92537 0 0 1-1.2332-0.34964 0.90503 0.92537 0 0 1 0.34168-1.261 0.90503 0.92537 0 0 1 1.2334 0.34909 0.90503 0.92537 0 0 1-0.34115 1.2612",
    fill: "#ff5252",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.22889
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7968 7.8537 0.0073-1.301c-1.108-0.0088-2.3772-0.0053-3.026-0.0021-0.04044 1.7102-0.02561 2.9806-0.04034 4.9079 0.92826-1.2699 1.9214-2.5141 3.059-3.6048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.2371 6.7867a0.90503 0.92537 0 0 0-1.2332 0.34964 0.90503 0.92537 0 0 0 0.34168 1.261 0.90503 0.92537 0 0 0 1.2334-0.34909 0.90503 0.92537 0 0 0-0.34115-1.2612",
    fill: "#ffa000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.22889
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.0409 4.7051-0.0073 1.301c1.108 0.0088 2.3772 0.0053 3.026 0.0021 0.04044-1.7102 0.02561-2.9806 0.04034-4.9079-0.92826 1.2699-1.9214 2.5141-3.059 3.6048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.6006 5.7722a0.90503 0.92537 0 0 0 1.2332-0.34964 0.90503 0.92537 0 0 0-0.34168-1.261 0.90503 0.92537 0 0 0-1.2334 0.34909 0.90503 0.92537 0 0 0 0.34115 1.2612",
    fill: "#00bcd4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.22889
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.0409 7.8537-0.0073-1.301c1.108-0.0088 2.3772-0.0053 3.026-0.0021 0.04044 1.7102 0.02561 2.9806 0.04034 4.9079-0.92826-1.2699-1.9214-2.5141-3.059-3.6048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.6006 6.7867a0.90503 0.92537 0 0 1 1.2332 0.34964 0.90503 0.92537 0 0 1-0.34168 1.261 0.90503 0.92537 0 0 1-1.2334-0.34909 0.90503 0.92537 0 0 1 0.34115-1.2612",
    fill: "#009688",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.22889
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMairiniLogo);
export default __webpack_public_path__ + "static/media/mairini-logo.bc92d1a92b9c3275cb5a525e1906b0e1.svg";
export { ForwardRef as ReactComponent };